import { inject, Injectable } from '@angular/core';
import { Geolocation, Position } from '@capacitor/geolocation';
import { ICoords } from '@okcargo-apps/shared-domain';
import { PlatformService } from '../platform';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  private readonly platform = inject(PlatformService);

  // constructor() {}

  async checkPermissions(): Promise<boolean> {
    if (this.platform.isHybrid) {
      const status = await Geolocation.checkPermissions();

      if (status.location !== 'granted') {
        const requestStatus = await Geolocation.requestPermissions();

        if (requestStatus.location === 'denied') {
          return false;
        }

        return requestStatus.location === 'granted';
      }

      return status.location === 'granted';
    } else {
      return true;
    }
  }

  async getCurrentPosition(): Promise<ICoords | null> {
    const hasPermission = await this.checkPermissions();
    if (!hasPermission) {
      throw new Error('permissions_not_granted');
    }

    try {
      if (this.platform.isHybrid) {
        const coordinates: Position = await Geolocation.getCurrentPosition();
        return {
          latitude: coordinates.coords.latitude,
          longitude: coordinates.coords.longitude,
        };
      } else {
        return new Promise<ICoords | null>((resolve, reject) => {
          if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const coords: ICoords = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                };
                resolve(coords);
              },
              (error) => {
                reject(error);
              },
            );
          } else {
            reject(new Error('geolocation_not_available'));
          }
        });
      }
    } catch (error) {
      return null;
    }
  }
}
